export default function StatusBadge({ status }) {
  const normalizedStatus = status || "pending";

  return (
    <span className={`badge status-${normalizedStatus}`}>
      {normalizedStatus}
    </span>
  );
}